export const FETCH_USERS = 'users/FETCH_USERS';
export const FETCH_IDENTITY_TOKEN = 'users/FETCH_IDENTITY_TOKEN';



// WEBPACK FOOTER //
// ./resources/scripts/greenmotion-shared/vuex/users/mutation-types.js